/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CommentsSectionMutationVariables = {
    user_id: string;
    work_order_id: string;
};
export type CommentsSectionMutationResponse = {
    readonly setWoOnlineUserStatus: {
        readonly user_id: string | null;
    } | null;
};
export type CommentsSectionMutation = {
    readonly response: CommentsSectionMutationResponse;
    readonly variables: CommentsSectionMutationVariables;
};



/*
mutation CommentsSectionMutation(
  $user_id: String!
  $work_order_id: String!
) {
  setWoOnlineUserStatus(user_id: $user_id, work_order_id: $work_order_id) {
    user_id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "user_id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "work_order_id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "user_id",
        "variableName": "user_id"
      },
      {
        "kind": "Variable",
        "name": "work_order_id",
        "variableName": "work_order_id"
      }
    ],
    "concreteType": "Status",
    "kind": "LinkedField",
    "name": "setWoOnlineUserStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "user_id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentsSectionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommentsSectionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "61241e78b0238357da057eff3beb494e",
    "id": null,
    "metadata": {},
    "name": "CommentsSectionMutation",
    "operationKind": "mutation",
    "text": "mutation CommentsSectionMutation(\n  $user_id: String!\n  $work_order_id: String!\n) {\n  setWoOnlineUserStatus(user_id: $user_id, work_order_id: $work_order_id) {\n    user_id\n  }\n}\n"
  }
};
})();
(node as any).hash = '77fe433b9972ddf3558f4e31cbfd306a';
export default node;
